module.exports = __webpack_public_path__ + "ckgd.cc18df4b.png";